import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getPmcLinkedEnterprise } from '../../features/pmc/pmcJourneySlice';
import useTitle from '../../hooks/useTitle';

const CannotProceed = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const isEnterprise = useSelector(getPmcLinkedEnterprise);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'pmcClientReg.cannotProceed.s8',
    'You cannot apply without a company registration or VAT number - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const handleBtnClick = () => {
    window.location.assign('/dashboardHub/dashboard-pmc');
  };

  return (
    <>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy('pmcReg.CannotProceed.s1', 'You cannot proceed')}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcClientReg.CannotProceed.s2',
          'To register a client and apply for a grant you must be able to prove your client is a UK registered business.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'pmcClientReg.CannotProceed.s3',
          'You can identify your business by providing either:'
        )}
      </p>

      <div className="govuk-body">
        <ul className="govuk-list--bullet">
          <li className="govuk-list--bullet">
            <Link
              className="govuk-link govuk-body govuk-!-font-size-19"
              to={
                isEnterprise === 'Yes'
                  ? '/pmcClientReg/linked-enterprise-number'
                  : '/pmcClientReg/company-registration-number'
              }
            >
              {copyProvider.getCopy(
                'pmcClientReg.CannotProceed.s4',
                'Company registration number:'
              )}
            </Link>
            {copyProvider.getCopy('landlordReg.CannotProceed.s5', ' or')}
          </li>
          <li className="govuk-list--bullet">
            <Link
              to="/pmcClientReg/company-VAT-number"
              className="govuk-link govuk-body govuk-!-font-size-19"
            >
              {copyProvider.getCopy(
                'pmcClientReg.CannotProceed.s6',
                'UK VAT registration number'
              )}
            </Link>
          </li>
        </ul>
      </div>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'pmcClientReg.CannotProceed.s7',
          "Cancel my client's account registration"
        )}
      </Button>
    </>
  );
};

export default CannotProceed;
